module.exports = __webpack_public_path__ + "img/qilin-stage6-sulking.ecacb79d.png";